<script setup>
import {nextTick, ref} from 'vue'
import CustomMask from "@/components/NewPC/CustomMask.vue";
const MaskRef = ref(null);
const VideoRef = ref(null);

const open = (src) => {
  VideoRef.value?.pause();
  MaskRef.value?.open();
  if (src) {
    nextTick(() => {
      VideoRef.value.src = src;
      VideoRef.value?.load();
      VideoRef.value?.play().then(() => {
        console.log('播放成功');
      }).catch(err => {
        console.error('播放失败:', err);
      });
    })
  }


}

defineExpose({open})

</script>

<template>
<custom-mask ref="MaskRef">
  <div class="content">
    <video ref="VideoRef" controls  @click.stop />
    <img class="video_close_icon" @click.stop="open(null)" src="@/assets/newPc/video_close.png" alt="">
  </div>
</custom-mask>
</template>

<style scoped lang="scss">
.content {
  width: 67.9296875vw;
  height: 35.0390625vw;
  margin-right: 5.46875vw;

  background: transparent url("@/assets/newPc/video_bg.png") no-repeat center center;
  background-size: cover;
  position: relative;

  video {
    margin-top: 7.1484375vw;
    margin-left: 19.765625vw;
    width: 33.8671875vw;
    height: 19.140625vw;
    border-radius: 20px;
    background-color: #000;
  }

  .video_close_icon {
    width: 3.6328125vw;
    height: 3.6328125vw;
    position: absolute;
    right: 11.25vw;
    top: 4.1796875vw;
    cursor: pointer;
  }
}
</style>